import { render, staticRenderFns } from "./FeedbackLayout.vue?vue&type=template&id=0e72f622&scoped=true"
import script from "./FeedbackLayout.vue?vue&type=script&lang=ts"
export * from "./FeedbackLayout.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackLayout.vue?vue&type=style&index=0&id=0e72f622&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e72f622",
  null
  
)

export default component.exports